import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBrand } from "../types/IBrand";

export interface IBrandQueryParameters {
    brand: RelationalValue<IBrand>;
}

export type IBrandQueryResult = IBrand;

export const brandQuery: IApiQueryFunction<IBrandQueryParameters> = ({ brand }) => {
    if (!brand) {
        return;
    }

    return {
        method: "GET",
        url: `/brands/${mapRelationalValue(brand)}`,
    };
};

export const useBrandQuery = createApiQueryHook<IBrandQueryParameters, IBrandQueryResult>(brandQuery);
